import React, { useEffect, useState } from "react";

import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Button, TopToolbar } from "react-admin";

import {
  CancelIcon,
  CloseIcon,
  ExceptionIcon,
  LinkIcon,
} from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { HelpButton } from "../../../components/common/HelpButton";
import { InventoryStatus } from "../../../utils/constants";
import { deepRedirect, trimDecimal } from "../../../utils/utils";
import { InventoryHelp } from "./InventoryHelp";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: "flex",
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    justifyContent: "space-between",
  },
  title: {
    paddingTop: theme.spacing(1),
  },
  dialogContent: {
    // https://stackoverflow.com/questions/47698037/how-can-i-set-a-height-to-a-dialog-in-material-ui
    minHeight: "50vh",
  },
}));

const InventoryEditActions = ({
  data,
  backPath,
  setProductIsOpen,
  ...props
}) => {
  const history = useHistory();
  const [isExceptionDialogOpen, setIsExceptionDialogOpen] = useState();

  const handleCreateWorkOrder = () => {
    deepRedirect(history, "/workOrders/create", backPath, {
      inventory: data,
    });
  };

  return (
    <TopToolbar>
      <HelpButton>
        <InventoryHelp {...props} />
      </HelpButton>
      <Button
        label="Exception"
        color="primary"
        onClick={() => setIsExceptionDialogOpen(true)}
      >
        <ExceptionIcon />
      </Button>
      <Button label="Product" onClick={() => setProductIsOpen(true)}>
        <LinkIcon />
      </Button>
      <Button
        label="Work Order"
        color="primary"
        onClick={handleCreateWorkOrder}
      />

      <BackButton {...props} backPath={backPath} />
      <ExceptionDialog
        {...props}
        data={data}
        isExceptionDialogOpen={isExceptionDialogOpen}
        setIsExceptionDialogOpen={setIsExceptionDialogOpen}
      />
    </TopToolbar>
  );
};

const ExceptionDialog = ({
  data,
  isExceptionDialogOpen,
  setIsExceptionDialogOpen,
  exceptions,
  setExceptions,
  quantityAdvised,
}) => {
  const classes = useStyles();
  const [otherExceptionNoteError, setOtherExceptionError] = useState();
  const [tempExceptions, setTempExceptinos] = useState({});
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  useEffect(() => {
    if (isExceptionDialogOpen) {
      setTempExceptinos({ ...exceptions });
    }
  }, [isExceptionDialogOpen]);

  const handleSave = () => {
    if (!validate()) return;
    debugger;
    const prevExceptions = { ...tempExceptions };
    prevExceptions.hasException =
      tempExceptions.overShipment ||
      tempExceptions.underShipment ||
      tempExceptions.isBroken ||
      tempExceptions.isRecalled ||
      tempExceptions.otherException;
    setExceptions({ ...prevExceptions });
    setIsExceptionDialogOpen(false);
  };

  const validate = () => {
    let isValid = true;
    setOtherExceptionError("");
    if (tempExceptions.otherException) {
      isValid = isValid && tempExceptions.otherExceptionNote;
      !tempExceptions.otherExceptionNote && setOtherExceptionError("Required");
    }
    return isValid;
  };

  const handleChange = (evt) => {
    const type = evt.target.name;
    const value = evt.target.checked;
    const prevExceptions = { ...tempExceptions };
    debugger;

    if (type === "underShipment") {
      prevExceptions.underShipment = value;
      if (value) {
        prevExceptions.underShipmentQuantity = trimDecimal(
          quantityAdvised - (data.quantityReceived || 0),
          3,
        );
        prevExceptions.overShipment = !value;
        prevExceptions.overShipmentNote = "";
      } else {
        prevExceptions.underShipmentNote = "";
        prevExceptions.underShipmentQuantity = 0;
      }
    } else if (type === "overShipment") {
      prevExceptions.overShipment = value;
      if (value) {
        prevExceptions.overShipmentQuantity = trimDecimal(
          (data.quantityReceived || 0) - quantityAdvised,
          3,
        );
        prevExceptions.underShipment = !value;
        prevExceptions.underShipmentNote = "";
      } else {
        prevExceptions.overShipmentNote = "";
        prevExceptions.overShipmentQuantity = 0;
      }
    } else if (type === "isRecalled") {
      prevExceptions.isRecalled = value;
      if (!value) {
        prevExceptions.recallNote = "";
      }
    } else {
      prevExceptions.otherException = value;
      if (!value) {
        prevExceptions.otherExceptionNote = "";
        setOtherExceptionError("");
      }
    }
    setTempExceptinos({ ...prevExceptions });
  };

  const handleCancel = () => {
    setIsExceptionDialogOpen(false);
    setTempExceptinos({});
  };

  const setNote = (prop, value) => {
    debugger;
    setTempExceptinos((tempExceptions) => ({
      ...tempExceptions,
      [prop]: value,
    }));
    if (prop === "otherExceptionNote" && value) setOtherExceptionError("");
  };

  const isOverShipmentDisabled = () => {
    if (data?.status === InventoryStatus.STORED) return true;
    return (
      tempExceptions.underShipment ||
      (tempExceptions.overShipment &&
        quantityAdvised < (data.quantityReceived || 0)) ||
      (!tempExceptions.overShipment &&
        quantityAdvised >= (data.quantityReceived || 0))
    );
  };

  const isUnderShipmentDisabled = () => {
    if (data?.status === InventoryStatus.STORED) return true;
    return (
      tempExceptions.overShipment ||
      (tempExceptions.underShipment &&
        quantityAdvised > (data.quantityReceived || 0)) ||
      (!tempExceptions.underShipment &&
        quantityAdvised <= (data.quantityReceived || 0))
    );
  };

  return (
    <Dialog
      open={isExceptionDialogOpen}
      maxWidth={isSmall ? "xl" : "md"}
      fullWidth={true}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography className={classes.title} variant="h6">
          Exception Manager
        </Typography>
        <IconButton aria-label="close" onClick={handleCancel}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel>
                <Typography variant="overline" color="textSecondary">
                  Exception Type
                </Typography>
              </FormLabel>
              <FormGroup row={!isSmall}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.overShipment}
                      onChange={handleChange}
                      name="overShipment"
                      disabled={isOverShipmentDisabled()}
                    />
                  }
                  label="Overshipment"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.underShipment}
                      onChange={handleChange}
                      name="underShipment"
                      disabled={isUnderShipmentDisabled()}
                    />
                  }
                  label="Undershipment"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.isDamaged}
                      name="isDamaged"
                      disabled={true}
                    />
                  }
                  label="Damaged"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.isRecalled}
                      onChange={handleChange}
                      name="isRecalled"
                    />
                  }
                  label="Recalled"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.otherException}
                      onChange={handleChange}
                      name="other"
                    />
                  }
                  label="Other"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          {tempExceptions.overShipment && (
            <Grid item xs={12}>
              <TextField
                name="overShipmentNote"
                label="Overshipment Notes"
                multiline
                autoFocus
                minRows={3}
                margin="dense"
                variant="outlined"
                fullWidth
                value={
                  tempExceptions.overShipmentNote
                    ? tempExceptions.overShipmentNote
                    : ""
                }
                onChange={(evt) =>
                  setNote("overShipmentNote", evt.target.value)
                }
                helperText={`Overshipment Qty: ${tempExceptions.overShipmentQuantity}`}
              />
            </Grid>
          )}
          {tempExceptions.underShipment && (
            <Grid item xs={12}>
              <TextField
                name="underShipmentNote"
                label="Undershipment Notes"
                multiline
                autoFocus
                minRows={3}
                margin="dense"
                variant="outlined"
                fullWidth
                value={
                  tempExceptions.underShipmentNote
                    ? tempExceptions.underShipmentNote
                    : ""
                }
                onChange={(evt) =>
                  setNote("underShipmentNote", evt.target.value)
                }
                helperText={`Undershipment Qty: ${tempExceptions.underShipmentQuantity}`}
              />
            </Grid>
          )}
          {tempExceptions.isRecalled && (
            <Grid item xs={12}>
              <TextField
                name="recallNote"
                label="Recall Notes"
                multiline
                autoFocus
                minRows={3}
                margin="dense"
                variant="outlined"
                fullWidth
                value={
                  tempExceptions.recallNote ? tempExceptions.recallNote : ""
                }
                onChange={(evt) => setNote("recallNote", evt.target.value)}
              />
            </Grid>
          )}
          {tempExceptions.otherException && (
            <Grid item xs={12}>
              <TextField
                name="otherExceptionNote"
                label="Other Notes"
                multiline
                autoFocus
                minRows={3}
                error={otherExceptionNoteError}
                helperText={otherExceptionNoteError}
                margin="dense"
                variant="outlined"
                required
                fullWidth
                value={
                  tempExceptions.otherExceptionNote
                    ? tempExceptions.otherExceptionNote
                    : ""
                }
                onChange={(evt) =>
                  setNote("otherExceptionNote", evt.target.value)
                }
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box>
          <Box>
            <Button
              label="Cancel"
              color="default"
              onClick={() => handleCancel()}
            >
              <CancelIcon />
            </Button>
            <Button
              label="Submit"
              onClick={() => handleSave()}
              color="primary"
            />
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default InventoryEditActions;
